<pdq-card variant="flat" color="white">
  <pdq-expandable-section id="multi-shipment-recipients-block" [cacheState]="true" [initialCollapsed]="false">
    <div sectionHeader class="section-heading">
      <pdq-heading element="h6">Recipients Block</pdq-heading>
      <p class="body-12-regular section-heading__subtitle">Shown in multi-address checkout</p>
    </div>

    <div class="recipients-block" [formGroup]="formGroup">
      <div class="subsection" formGroupName="addRecipientCard">
        <div class="subsection__heading">
          <p class="body-14-medium">Add recipient card</p>
          <p class="body-12-regular section-heading__subtitle">Invites the buyer to add a recipient</p>
        </div>
        <pdq-input
          label="Card title"
          formControlName="title"
          placeholder="Choose their gift"
          [invalid]="addRecipientCard.controls.title.dirty && addRecipientCard.controls.title.invalid"
          invalidMsg="Card title is required"></pdq-input>
        <div class="field">
          <p class="body-14-medium">Card help text</p>
          <rich-textarea
            [initialContent]="addRecipientCard.controls.helpText.value"
            (contentChange)="onRichTextChange(addRecipientCard.controls.helpText, $event)"
            placeholder="Pick items, a delivery date, and an optional gift note for this recipient."
            [invalid]="addRecipientCard.controls.helpText.dirty && addRecipientCard.controls.helpText.invalid"
            errorMsg="Card help text is required"></rich-textarea>
        </div>
        <pdq-input
          label="Button label"
          formControlName="buttonLabel"
          placeholder="Choose items"
          [invalid]="addRecipientCard.controls.buttonLabel.dirty && addRecipientCard.controls.buttonLabel.invalid"
          invalidMsg="Button label is required"></pdq-input>
      </div>

      <div class="subsection" formGroupName="addAnotherRecipientCard">
        <pdq-checkbox
          formControlName="enabled"
          label="Different copy for further recipients"
          secondaryLabel="When off, the card above is reused once a recipient exists."></pdq-checkbox>
        @if (addAnotherRecipientCard.controls.enabled.value) {
          <pdq-input
            label="Card title"
            formControlName="title"
            placeholder="Add another recipient"
            [invalid]="addAnotherRecipientCard.controls.title.dirty && addAnotherRecipientCard.controls.title.invalid"
            invalidMsg="Card title is required"></pdq-input>
          <div class="field">
            <p class="body-14-medium">Card help text</p>
            <rich-textarea
              [initialContent]="addAnotherRecipientCard.controls.helpText.value"
              (contentChange)="onRichTextChange(addAnotherRecipientCard.controls.helpText, $event)"
              placeholder="Pick items, a delivery date, and an optional gift note for this recipient."
              [invalid]="
                addAnotherRecipientCard.controls.helpText.dirty && addAnotherRecipientCard.controls.helpText.invalid
              "
              errorMsg="Card help text is required"></rich-textarea>
          </div>
          <pdq-input
            label="Button label"
            formControlName="buttonLabel"
            placeholder="Choose items"
            [invalid]="
              addAnotherRecipientCard.controls.buttonLabel.dirty && addAnotherRecipientCard.controls.buttonLabel.invalid
            "
            invalidMsg="Button label is required"></pdq-input>
        }
      </div>

      <div class="subsection">
        <div class="subsection__heading">
          <p class="body-14-medium">Unassigned items warning</p>
          <p class="body-12-regular section-heading__subtitle">
            Emphasis for the "items still need to be assigned" message shown under the Recipients list.
          </p>
        </div>
        <pdq-dropdown
          title="Tone"
          formControlName="unassignedItemsWarningTone"
          [options]="textToneOptions"></pdq-dropdown>
      </div>
    </div>
  </pdq-expandable-section>
</pdq-card>
